/* analytics.js — Larrysa's Bakery · GA4
   Os eventos só são emitidos depois de a Shopify autorizar análise.
   Expõe window.LTrack(event, params), sem dados pessoais.
*/
(function () {
  'use strict';

  window.dataLayer = window.dataLayer || [];

  /* ---- product_area auto-detection ---- */
  function getProductArea() {
    var p = location.pathname;
    if (/^\/products\//.test(p)) return 'bakery';
    if (/festa/.test(p)) return 'festa';
    if (/menu/.test(p)) return 'menu';
    if (/encomend/.test(p)) return 'encomendas';
    if (/bakery|bolo|cheesecake|sobremesa|salgado|tarte/.test(p)) return 'bakery';
    if (/index|hub|entrada/.test(p) || p === '/') return 'bakery';
    return 'outros';
  }

  // Closed editorial attribution. Arbitrary short tokens can still be personal.
  var campaignEnums = {
    utm_source: { instagram: 'instagram', tiktok: 'tiktok', google: 'google', whatsapp: 'whatsapp', offline: 'offline', qr: 'offline', website: 'website', direct: 'direct', referral: 'referral' },
    utm_medium: { social: 'social', organic: 'organic', paid: 'paid', cpc: 'paid', message: 'message', qr: 'qr', referral: 'referral', direct: 'direct' },
    // The four Hub distribution links are approved in the Hub specification.
    utm_campaign: { hub: 'hub' },
    utm_content: { profile: 'profile', counter: 'counter', share: 'share' }
  };
  function campaignValue(key, value) {
    if (typeof value !== 'string') return '';
    var clean = value.trim().toLowerCase();
    return Object.prototype.hasOwnProperty.call(campaignEnums[key], clean) ? campaignEnums[key][clean] : '';
  }

  function campaign() {
    try {
      var query = new URLSearchParams(location.search || '');
      return {
        campaign_source: campaignValue('utm_source', query.get('utm_source')),
        campaign_medium: campaignValue('utm_medium', query.get('utm_medium')),
        campaign_name: campaignValue('utm_campaign', query.get('utm_campaign')),
        campaign_content: campaignValue('utm_content', query.get('utm_content'))
      };
    } catch (error) { return {}; }
  }

  var attribution = campaign();

  var hubFields = {
    hub_dialogue_shown: ['dialogue_id', 'product_handle', 'channel'],
    hub_social_opened: ['destination', 'product_handle', 'target_type', 'placement'],
    hub_assistant_opened: ['product_handle', 'entry_point', 'locale', 'action_type', 'state'],
    hub_assistant_message_sent: ['locale', 'action_type', 'state', 'product_handle'],
    hub_assistant_action_shown: ['locale', 'action_type', 'state', 'product_handle'],
    hub_assistant_action_used: ['locale', 'intent', 'action_type'],
    hub_assistant_result: ['locale', 'intent', 'action_type', 'result'],
    hub_assistant_handoff_requested: ['locale', 'action_type', 'state', 'product_handle'],
    hub_assistant_handoff_completed: ['locale', 'action_type', 'state', 'product_handle'],
    hub_assistant_skipped: ['product_handle'],
    hub_google_review_opened: ['placement'],
    hub_official_site_opened: ['placement'],
    hub_review_viewed: ['review_id', 'source', 'product_handle']
  };
  var hubEnums = {
    locale: ['pt', 'en'], state: ['ai', 'human'],
    intent: ['answer_fact', 'clarify', 'show_products', 'open_product', 'compare_products', 'open_planner', 'propose_cart_item', 'request_human', 'continue_whatsapp'], result: ['answered', 'clarified', 'acted', 'handed_off', 'failed'],
    action_type: ['open_product', 'compare_products', 'open_planner', 'propose_cart_item', 'request_human', 'continue_whatsapp', 'add_confirmed_item'],
    dialogue_id: ['help', 'people', 'instagram', 'tiktok', 'google'],
    channel: ['assistant', 'instagram', 'tiktok', 'google'],
    destination: ['instagram', 'tiktok'], target_type: ['post', 'profile'],
    placement: ['service_rail', 'dialogue', 'reviews'], entry_point: ['mascot', 'invitation'],
    source: ['google', 'instagram', 'whatsapp', 'other']
  };
  var eventFields = {
    menu_category_selected: ['category'], product_option_selected: ['product', 'option', 'value'],
    product_syrup_selected: ['product', 'syrup'], whatsapp_click: ['intent_level', 'trigger_element', 'page_path', 'product_name'],
    order_brief_started: ['product_name'], planner_started: ['step', 'resumed', 'mundo'],
    planner_step_completed: ['step'], planner_validation_error: ['step', 'field'],
    planner_reviewed: ['guest_count_band', 'component_count', 'level', 'reception'],
    select_item: ['item_list_name', 'item_list_id', 'items'], view_item_list: ['item_list_name', 'item_list_id', 'items'],
    view_item: ['currency', 'value', 'items'], begin_checkout: ['page_path'], add_to_cart: ['page_path', 'currency', 'value', 'items'], scroll_depth: ['percent', 'page_path'],
    share: ['method', 'content_type', 'item_id', 'item_name'], search_open: [], search_category_click: ['item_category'],
    search_recent_click: ['item_id', 'item_category', 'position'], search_suggestion_click: ['item_id', 'item_category', 'position'], search_submit: ['result_count'],
    planner_world_selected: ['mundo', 'source'], planner_result_viewed: ['mundo', 'tipoFesta', 'pessoasRange', 'package_count'],
    planner_step_complete: ['from_step', 'to_step', 'mundo', 'tipoFesta', 'pessoasRange'],
    order_planner_complete: ['source', 'package', 'mundo', 'tipo_festa', 'estimated_total', 'estimated_per_person', 'delivery'],
    group_choice_created: ['option_count'], group_choice_voted: ['option_count'], group_choice_used: ['option_count'],
    group_choice_shared: ['option_count'], group_choice_link_copied: ['option_count']
  };
  function safeParams(event, params) {
    var fields = Object.prototype.hasOwnProperty.call(hubFields, event) ? hubFields[event] : Object.prototype.hasOwnProperty.call(eventFields, event) ? eventFields[event] : null;
    if (!fields) return null;
    var result = {};
    fields.forEach(function (key) {
      var value = params && params[key];
      if (value == null) return;
      if (hubFields[event]) {
        if (hubEnums[key] ? hubEnums[key].indexOf(value) !== -1 : typeof value === 'string' && /^[a-z0-9][a-z0-9_-]{0,120}$/.test(value)) result[key] = value;
      } else if (key === 'items' && Array.isArray(value)) {
        result.items = value.slice(0, 100).map(function (item) {
          var clean = {};
          ['item_id', 'item_name', 'item_category', 'price', 'index', 'quantity'].forEach(function (field) {
            if (item && typeof item[field] === 'number' && Number.isFinite(item[field])) clean[field] = item[field];
            else if (item && typeof item[field] === 'string' && item[field].length <= 160 && !/[?\#]|:\/\//.test(item[field])) clean[field] = item[field];
          });
          return clean;
        });
      } else if (typeof value === 'number' && Number.isFinite(value) || typeof value === 'boolean') result[key] = value;
      else if (typeof value === 'string' && value.length <= 160 && !/[?\#]|:\/\//.test(value)) result[key] = value;
    });
    return result;
  }
  // Session-local impression IDs only: no user identifier or persistent storage.
  var seenImpressions = {};
  function impressionKey(event, params) {
    var id = event === 'hub_dialogue_shown' ? params.dialogue_id : event === 'hub_review_viewed' ? params.review_id : '';
    return id ? 'larrysas-hub-metric:' + event + ':' + id : '';
  }

  /* ---- consented dataLayer / gtag event ---- */
  function push(event, params) {
    if (window.LARRYSA_ANALYTICS_ALLOWED !== true) return false;
    var filtered = safeParams(event, params);
    if (!filtered) return false;
    var key = impressionKey(event, filtered);
    if (key) {
      if (seenImpressions[key]) return false;
      try { if (window.sessionStorage.getItem(key) === '1') return false; } catch (error) {}
    }
    try {
      var payload = { event: event, product_area: getProductArea() };
      Object.keys(filtered).forEach(function (k) { payload[k] = filtered[k]; });
      Object.keys(attribution).forEach(function (key) {
        if (attribution[key]) payload[key] = attribution[key];
      });
      if (window.LARRYSA_INTERNAL_TRAFFIC) payload.traffic_type = 'internal';
      /* gtag escreve na própria dataLayer; enviar pelos dois caminhos
         duplicaria eventos quando o script GA4 já está carregado. */
      if (typeof window.gtag === 'function') {
        window.gtag('event', event, payload);
      } else {
        window.dataLayer.push(payload);
      }
      if (key) {
        seenImpressions[key] = true;
        try { window.sessionStorage.setItem(key, '1'); } catch (error) {}
      }
      return true;
    } catch (error) { return false; }
  }

  /* LTrack é a API pública usada por festa/app.js e qualquer outro JS */
  window.LTrack = push;

  /* ---- WhatsApp click tracking ---- */
  function waContext(el) {
    var ctx = '';
    var node = el;
    for (var i = 0; i < 6; i++) {
      if (!node) break;
      ctx += ' ' + (node.className || '') + ' ' + (node.id || '');
      node = node.parentElement;
    }
    return ctx;
  }

  function waIntentLevel(el) {
    var ctx = waContext(el);
    if (/fpv1-whatsapp/i.test(ctx)) return 'high';
    if (/gate|vh-prod|pk__cta|encomendar|product-card/i.test(ctx)) return 'high';
    if (/nav__|footer|fskip|fwhat/i.test(ctx)) return 'low';
    return 'medium';
  }

  function waTriggerEl(el) {
    var ctx = waContext(el);
    if (/fpv1-whatsapp/i.test(ctx)) return 'planner_result';
    if (/gate|vh-prod/i.test(ctx)) return 'product_card';
    if (/pk__cta/i.test(ctx)) return 'planner_result';
    if (/nav__/.test(ctx)) return 'nav';
    if (/footer/.test(ctx)) return 'footer';
    if (/fskip/.test(ctx)) return 'planner_skip';
    if (/is-cta/.test(ctx)) return 'hero_cta';
    if (/btn-coral/.test(ctx)) return 'section_cta';
    return 'other';
  }

  function setupWATracking() {
    document.addEventListener('click', function (event) {
      var a = event.target && event.target.closest && event.target.closest('a[href*="wa.me"]');
      if (!a) return;
        if (window.LARRYSA_ANALYTICS_ALLOWED === true && attribution.campaign_source && attribution.campaign_name) {
          try {
            var waUrl = new URL(a.getAttribute('href'));
            var currentText = waUrl.searchParams.get('text') || '';
            var reference = [attribution.campaign_source, attribution.campaign_name, attribution.campaign_content].filter(Boolean).join('-');
            if (!currentText.includes('Ref: ')) {
              waUrl.searchParams.set('text', currentText + '\nRef: ' + reference);
              a.setAttribute('href', waUrl.toString().replace(/\+/g, '%20'));
            }
          } catch (error) {}
        }
        var modal = a.closest('.pmx');
        var productName = modal && modal.querySelector('#pmxNome');
        var whatsappDetail = {
          intent_level: waIntentLevel(a),
          trigger_element: waTriggerEl(a),
          page_path: location.pathname
        };
        if (productName) whatsappDetail.product_name = productName.textContent.trim();
        push('whatsapp_click', whatsappDetail);
        if (modal && productName) push('order_brief_started', { product_name: productName.textContent.trim() });
    }, true);
  }

  function textOf(element) {
    return element && typeof element.textContent === 'string' ? element.textContent.trim() : '';
  }

  function setupChoiceTracking() {
    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      var tab = target.closest('.tab[data-tab]');
      if (tab && tab.getAttribute('data-tab')) push('menu_category_selected', { category: tab.getAttribute('data-tab') });

      var modalOption = target.closest('#pmxEixos .pmx__chip');
      if (modalOption) {
        var optionGroup = modalOption.closest('.pmx__eixo');
        var option = textOf(optionGroup && optionGroup.querySelector('.pmx__rot'));
        var modalProduct = textOf(document.querySelector('#pmxNome'));
        var value = textOf(modalOption);
        if (modalProduct && option && value) push('product_option_selected', { product: modalProduct, option: option, value: value });
      }

      var modalSyrup = target.closest('#pmxCaldas .pmx__chip');
      if (modalSyrup) {
        var syrupProduct = textOf(document.querySelector('#pmxNome'));
        var syrup = textOf(modalSyrup);
        if (syrupProduct && syrup) push('product_syrup_selected', { product: syrupProduct, syrup: syrup });
      }
    }, true);

    document.addEventListener('change', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      var product = textOf(document.querySelector('.product__title'));
      var variant = target.closest('input[name="product-variant"]');
      if (variant) {
        var variantValue = variant.value || variant.getAttribute('value');
        if (product && variant.checked && variantValue) push('product_option_selected', { product: product, option: 'format', value: variantValue });
        return;
      }
      var syrup = target.closest('input[name="product-calda"]');
      if (syrup) {
        var syrupValue = syrup.value || syrup.getAttribute('value');
        if (product && syrup.checked && syrupValue) push('product_syrup_selected', { product: product, syrup: syrupValue });
      }
    }, true);

    document.addEventListener('larrysa:planner-progress', function (event) {
      var detail = event && event.detail;
      if (!detail || !['started', 'step_completed', 'validation_error'].includes(detail.action)) return;
      if (!Number.isInteger(detail.step) || detail.step < 1 || detail.step > 3) return;
      var payload = { step: detail.step };
      if (detail.action === 'validation_error') {
        if (!['people', 'date', 'budget'].includes(detail.field)) return;
        payload.field = detail.field;
      }
      push('planner_' + detail.action, payload);
    });

    document.addEventListener('larrysa:planner-reviewed', function (event) {
      var detail = event && event.detail;
      if (!detail || typeof detail.component_count !== 'number' || !detail.guest_count_band || !detail.level || !detail.reception) return;
      push('planner_reviewed', {
        guest_count_band: detail.guest_count_band,
        component_count: detail.component_count,
        level: detail.level,
        reception: detail.reception
      });
    });
  }

  function setupCommerceTracking() {
    document.addEventListener('click', function (event) {
      var card = event.target && event.target.closest && event.target.closest('[data-modal-card]');
      if (card) {
        var priceText = card.getAttribute('data-price') || '';
        var price = Number.parseFloat(priceText.replace(/[^\d,.]/g, '').replace(/\./g, '').replace(',', '.'));
        var item = {
          item_id: card.getAttribute('data-handle') || card.getAttribute('data-pid') || '',
          item_name: card.getAttribute('data-name') || '',
          item_category: card.getAttribute('data-kicker') || ''
        };
        if (Number.isFinite(price)) item.price = price;
        var list = card.getAttribute('data-list');
        if (list) push('select_item', { item_list_name: list, items: [item] });
        push('view_item', { currency: 'EUR', value: Number.isFinite(price) ? price : 0, items: [item] });
      }

      var checkout = event.target && event.target.closest && event.target.closest('[name="checkout"], [href*="/checkout"]');
      if (checkout) push('begin_checkout', { page_path: location.pathname });
    }, true);

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (form && form.matches('form[action*="/cart/add"]')) push('add_to_cart', { page_path: location.pathname });
    }, true);
  }

  /* ---- Scroll depth (50% e 90%) ---- */
  function setupScrollTracking() {
    var fired = {};
    function check() {
      var scrolled = window.scrollY || document.documentElement.scrollTop;
      var total = document.documentElement.scrollHeight - window.innerHeight;
      if (total <= 0) return;
      var pct = Math.round((scrolled / total) * 100);
      [50, 90].forEach(function (t) {
        if (pct >= t && !fired[t]) {
          fired[t] = true;
          push('scroll_depth', { percent: t, page_path: location.pathname });
        }
      });
    }
    window.addEventListener('scroll', check, { passive: true });
  }

  /* ---- Init ---- */
  function init() {
    setupWATracking();
    setupChoiceTracking();
    setupCommerceTracking();
    setupScrollTracking();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());
